import Router from 'vue-router';

export default function (Vue) {
	Vue.use(Router);
	const config = new Router({
		mode: 'history',
		routes: [
			{
				path: '/',
				name: 'page-home',
				// component: () => import('@/pages/page-home'),
				redirect: '/',
				component: () => import('@/pages/page-router'),
				children: [
					// {
					// 	path: '',
					// 	name: 'page-home-new',
					// 	component: () => import('@/pages/page-home-new'),
					// },
					{
						path: '',
						name: 'page-home-new-cm',
						component: () => import('@/pages/page-home-new-cm'),
					},
					{
						path: 'market-place',
						name: 'market-place',
						redirect: 'market-place/comercios',
						component: () => import('@/pages/market-place/page-market-place'),
						children: [
							{
								path: 'comercios',
								name: 'commerce-view',
								component: () => import('@/pages/market-place/page-commerce-view'),
							},
							{
								path: 'comercios/:slug/inicio',
								name: 'commerce-home',
								component: () => import('@/pages/market-place/page-commerce-home'),
								props: true,
							},
							{
								path: ':product/detalle',
								name: 'product-detail',
								component: () => import('@/pages/market-place/page-product-detail'),
								props: true,
							},
						],
					},
					{
						path: 'abrir-tienda',
						name: 'open-ecommerce',
						component: () => import('@/pages/page-open-ecommerce'),
					},
					{
						path: 'activa-tu-app',
						name: 'simulator',
						component: () => import('@/pages/page-simulator'),
					},
					{
						path: 'c/:commerceCode',
						name: 'products-catalog',
						props: true,
						component: () => import('@/pages/page-products-catalog'),
					},
					{
						path: 'activa-tu-catalogo',
						name: 'simulator',
						component: () => import('@/pages/page-activa-catalogo-two'),
					},
					{
						path: 'japisale-planes',
						name: 'japisale-planes',
						component: () => import('@/pages/page-japisale-planes'),
					},
					{
						path: 'plan-gratuito',
						name: 'plans-gratuitous',
						component: () => import('@/pages/page-plan-gratuitous'),
					},
					{
						path: 'asesor/:nombre',
						name: 'asesores',
						component: () => import('@/pages/page-advisers'),
						props: true,
					},
				],
			},
		],
	});
	config.beforeEach((to, from, next) => next());
	return config;
}



// WEBPACK FOOTER //
// ./src/router/index.js